import { React, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Header from '../../layout/Header'
import Footer from '../../layout/Footer'
import { decryptFromStore, encryptAndStore } from '../../helper/sessionStore'
import { decryptFromStoreLoc, encryptAndStoreLoc } from '../../helper/localStore'
import { validate } from './RegisterSchema';
import { getServerURL } from '../../helper/envConfig'
import { useNavigate } from 'react-router-dom'; // Import useHistory for redirection
import api from '../../helper/api'
// import 'toastr/build/toastr.min.css';
import { toast } from 'react-toastify';
import { CourseContext } from '../../context/CourseContext'
import { useTranslation } from 'react-i18next';
import '../../i18n'; // important to import
const BusinessUserDetails = () => {
         const { t } = useTranslation([['BusinessUserDetails','common']]); 

    const { email } = useContext(CourseContext);


    const [role, setRole] = useState();
    const serverURL = getServerURL();
    const history = useNavigate(); // Get the history object for redirection
    const location = useLocation()
     console.log("location", location);

    useEffect(() => {
        // Retrieve and decrypt stored information
        const decryptedInfoRole = decryptFromStore('role');
        const decryptedInfoSubRole = decryptFromStore('sub-role');
        const decryptedEmailUserName = decryptFromStore('emailUserName');

        if (decryptedEmailUserName) {
            setValues((prevValues) => ({
                ...prevValues,
                username: decryptedEmailUserName
            }));
        }

        if (decryptedInfoSubRole !== null) {
            setRole(decryptedInfoSubRole);
        } else {
            setRole(decryptedInfoRole);
        }

    }, []);

    const initialValues = {
        username: "",
        email: email || "",
        password: "",
        is_active: true
    };

    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [submitCount, setSubmitCount] = useState(0);

   const handleChange = (e) => {
  const { name, value, checked, type } = e.target;
  const newValue = type === "checkbox" ? checked : value;

  const updatedValues = { ...values, [name]: newValue };

  if (submitCount > 0) {
    const validationErrors = validate(updatedValues, t); //Pass t For translation 

    setErrors((prevErrors) => {
      const newErrors = { ...validationErrors };

      
      if (!validationErrors[name]) {
        delete newErrors[name];
      }

      return newErrors;
    });
  }

  setValues(updatedValues);
};

    const sendAIcertificate = async(token) => {
        try {
            const response = await api.postWithManualToken(`${serverURL}trails/ai-certificate/`, token,  { });
            console.log("AI certificate response", response);
            toast.success(response.data.message)
        } catch (error) {
        }
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        const updatedValues = { ...values }; // Create a copy of the values object

        const validationErrors = validate(updatedValues, t);
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            updatedValues.role = role
            updatedValues.is_active = true
            updatedValues.is_come_from_free_trail = (location?.state?.is_come_from_free_trail && (role == 12 || role == 2)) ? location?.state?.is_come_from_free_trail: false

            try {
                const response = await api.post(`${serverURL}users/register/`, updatedValues);
                if (response.data) {
                    // localStorage.setItem("token", response.data.token.access);
                    if (response.data?.data?.is_one_time_password) {
                        history("/change-password")
                    }
                    encryptAndStoreLoc("user", response?.data?.data);
                    //  AI certificate sending logic
                    if(location?.state?.sendCertificate) {
                        const token = response?.data?.token?.access;
                        await sendAIcertificate(token);
                    }
                    toast.success(response.data.message);
                    history("/verify-email")
                }

            } catch (error) {
                console.log(error);
                toast.error(error.response.data.message,);
            }
        }
    };


    return (
        <> 
            <Header />
            <section>

                <div className="container-fluid">
                    <div className="sign-up-main">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-12 col-md-6 position-relative bg-primary d-flex justify-content-center align-items-center sign-up-col vh-md-100">
                                <img
                                    src="./login/individual-user-vector-1.png"
                                    className="sing-vector-1"
                                    alt=""
                                />
                                <img
                                    src="./login/woman-home.webp"
                                    className="project-team"
                                    alt=""
                                />
                                <img
                                    src="./login/individual-user-vector-2.png"
                                    className="sing-vector-2"
                                    alt=""
                                />
                            </div>
                            <div className="col-12 col-md-6 position-relative d-flex justify-content-center align-items-start align-items-md-center sign-up-col sign-up-col-sm vh-md-100">
                                <div className="col-12 col-md-12 col-lg-10 col-xl-9">
                                    <form className="row g-3 form-main" >
                                        <div className="col-md-12">
                                            {/* <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label htmlFor="inputState" className="form-label">
                                                    What’s your role?
                                                </label>
                                                <select id="inputState" className="form-select">
                                                    <option>Choose...</option>
                                                    <option selected="">Manager</option>
                                                </select>
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label htmlFor="inputState" className="form-label">
                                                    What topic/category would you like to explore?
                                                </label>
                                                <select id="inputState" className="form-select">
                                                    <option>Choose...</option>
                                                    <option selected="">IT and Security</option>
                                                </select>
                                            </div> */}
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label className="form-label">{t("username")} </label>
                                                <input
                                                    className="form-control"
                                                    placeholder={t("enteryouusername")}
                                                    name="username"
                                                    onChange={handleChange}
                                                    value={values.username}
                                                    type='text'
                                                />
                                                <div className='error' >{errors?.username}</div>
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label className="form-label">{t("emailaddress")} </label>
                                                <input
                                                    className="form-control"
                                                    placeholder={t("emailplaceholder")}
                                                    name="email"
                                                    onChange={handleChange}
                                                    value={values.email}
                                                    type='email'
                                                />
                                                <div className='error' >{errors?.email}</div>
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label className="form-label">{t("password")} </label>
                                                <input
                                                    type="password"
                                                    name='password' value={values.password}
                                                    className="form-control"
                                                    id="inputPassword4"
                                                    onChange={handleChange}
                                                    placeholder={t("enteryourpassword")}
                                                />
                                                <div className='error' >{errors?.password}</div>
                                            </div>
                                            {/* <div className="col-md-12 col-lg-12 col-xl-8 d-flex justify-content-end">
                                                <Link
                                                    type="button"
                                                    to="/sign-in"
                                                    // onClick={(e) => (handleSubmit(e), setSubmitCount(1))
                                                    // }
                                                    className="btn-explore d-flex align-items-center fw-400 gap-3 rounded-2"
                                                >
                                                    SignIn
                                                </Link>
                                            </div> */}
                                            <div className="col-md-12 col-lg-12 col-xl-8 d-flex justify-content-end">
                                                <Link
                                                    type="button"
                                                    // to="/subscription"
                                                    onClick={(e) => (handleSubmit(e), setSubmitCount(1))
                                                    }
                                                    className="btn-explore d-flex align-items-center fw-400 gap-3 rounded-2"
                                                >
                                                    {t("submit")}
                                                </Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default BusinessUserDetails